module.exports = __webpack_public_path__ + "static/media/london_hornsoffa_djup_tyg_alis_320_beige_miljo_2023.4fa4bad8.jpg";